const initialState = {
    noData: false,
    surveysList: {},
    surveys: {},
    fetching: false,
    fetched: false,
    error: null,
    percent_complete: 0,
    complete_export: false
}

export function surveysReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_SURVEYS_LIST_TOKEN": {
            return { ...state, fetching: true, fetched: false, error: null }
        }
        case "FETCH_SURVEYS_LIST": {
            return { ...state, fetching: true, fetched: false, error: null, surveys: action.payload.data }
        }
        case "FETCH_SURVEYS_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }
        case "FETCH_SURVEYS_LIST_FULFILLED": {  
            action.payload.data.surveys.sort((a, b) => {
                if (a.average_score < b.average_score)
                    return 1
                else if (a.average_score > b.average_score)
                    return -1
                else {
                    if (a.field_name < b.field_name)
                        return -1
                    else if (a.field_name > b.field_name)
                        return 1
                    else 
                        return 0
                }
            })

            return { ...state, fetching: false, fetched: true, noData: action.payload.data.surveys.length == 0, surveysList: action.payload.data }
        }
        case "FETCH_SURVEY_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }
        case "EXPORT_EXCEL_SURVEYS": {
            return { ...state, fetching: false, fetched: true, filter: action.payload.data }
        }
        case "PERCENTAGE_COMPLETE_SURVEYS": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "EXPORT_START_SURVEYS": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }
        case "FINISH_EXPORT_SURVEYS": {
            return { ...state, fetching: false, fetched: true, percent_complete: action.payload.data }
        }
        case "COMPLETE_EXPORT_SURVEYS": {
            return { ...state, fetching: false, fetched: true, complete_export: action.payload.data }
        }    

        default:
            return state
    }
}
